import { render } from "./BookingLiveChatWidget.vue?vue&type=template&id=38d374aa&scoped=true"
import script from "./BookingLiveChatWidget.vue?vue&type=script&lang=js"
export * from "./BookingLiveChatWidget.vue?vue&type=script&lang=js"

import "./BookingLiveChatWidget.vue?vue&type=style&index=0&id=38d374aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d374aa"]])

export default __exports__